var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.playList),function(movie,idx){return _c('li',{key:idx},[_vm._v(" "+_vm._s(movie.title)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }